import Networking from "./components/Networking/Networking.vue";

require('./bootstrap');

import { createApp, onMounted } from "vue";

import { VueReCaptcha } from 'vue-recaptcha-v3';
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

import { ZiggyVue } from 'ziggy';

import { StoryblokVue, apiPlugin } from "@storyblok/vue";
import { createPinia } from 'pinia'


import Navbar from './components/Navbar.vue';
import Steps from './components/Schedule/Steps.vue';
import Program from './components/Program/Program.vue';
import AmbienceCarousel from './components/Ambience/Carousel.vue';
import Faqs from './components/Faq/Faqs.vue';
import HappeningForm from './components/Happening/Form.vue';
import VotingForm from './components/Voting/VotingForm.vue';
import RegistrationEshoper from './components/RegistrationEshoper/RegistrationEshoper.vue';
import MoreAboutShopcamp from './components/MoreAboutShopcamp.vue';
// import PartnersCard from './components/Partners/PartnersCard.vue';
// import MainPartners from './components/Partners/GridTypes/MainPartners.vue';
import SupportPartners from './components/Partners/GridTypes/SupportPartners.vue';
// import Partners from './components/Partners/GridTypes/Partners.vue';
// import MedialPartners from './components/Partners/GridTypes/MedialPartners.vue';
import Newsletter from './components/Newsletter/Newsletter.vue';
import SpeakersCarousel from './components/Speakers/Carousel.vue';
import LoginForm from './components/Login/Login.vue';
import Notifications from "./components/Notifications/Notifications.vue";
import LogoutForm from "./components/LogoutForm.vue";
import Workshops from "./components/Workshop/Workshops.vue";
import AssignedWorkshops from "./components/Profile/AssignedWorkshops.vue";
import PartnerSimpleshop from "./components/SimpleshopForms/Partner.vue";
import StandardSimpleshop from "./components/SimpleshopForms/Standard.vue";
import StandardSimpleshopLateBird from "./components/SimpleshopForms/StandardLateBird.vue";
import AfternoonSimpleshop from "./components/SimpleshopForms/Afternoon.vue";
import RecordingsSimpleshop from "./components/SimpleshopForms/Recordings.vue";
import Partners from "./components/Partners/Index.vue";
import ConferenceDate from "./components/ConferenceDate.vue";
import LecturesCount from "./components/LecturesCount.vue";
import AttendeesCount from "./components/AttendeesCount.vue";
import FooterDate from "./components/FooterDate.vue";
import ForMedia from "./components/ForMedia.vue";
import CalendarDropdown from "./components/CalendarDropdown.vue";
import ModalAfterRegistrationMessage from "./components/ModalAfterRegistrationMessage.vue";

import useStoryBlokData from './composables/useStoryBlokData';
import { useStoryBlokStore } from "./stores/storyblok";
import { useStoryblokBridge } from "@storyblok/vue";

const app = createApp({
    components: {
        Navbar,
        Steps,
        Program,
        Faqs,
        VotingForm,
        RegistrationEshoper,
        MoreAboutShopcamp,
        // PartnersCard,
        // MainPartners,
        // Partners,
        // MedialPartners,
        Partners,
        Newsletter,
        HappeningForm,
        SpeakersCarousel,
        AmbienceCarousel,
        LoginForm,
        SupportPartners,
        Notifications,
        LogoutForm,
        Workshops,
        AssignedWorkshops,
        PartnerSimpleshop,
        StandardSimpleshop,
        StandardSimpleshopLateBird,
        ConferenceDate,
        LecturesCount,
        AttendeesCount,
        FooterDate,
        ForMedia,
        CalendarDropdown,
        AfternoonSimpleshop,
        RecordingsSimpleshop,
        ModalAfterRegistrationMessage,
        Networking
    },


    setup() {
      const { getStoryBlokData} = useStoryBlokData();
      const storyBlokStore = useStoryBlokStore();

      onMounted(() => {
        getStoryBlokData().then(({data}) => {
          storyBlokStore.setStoryBlokData(data);

          useStoryblokBridge(data.story.id, (data) => {
            storyBlokStore.setStoryBlokData(data);
          });
        });
      });
    }
});

if(process.env.NODE_ENV === 'production') {
    Bugsnag.start({
        apiKey: "e1f46ee43a7c55fd86dfad5c377c3cf3",
        plugins: [new BugsnagPluginVue()]
    });

    const bugsnagVue = Bugsnag.getPlugin("vue");
    app.use(bugsnagVue);
}

const pinia = createPinia()


app.use(VueReCaptcha, {
    siteKey: "6LfC4ycpAAAAALTjvUWCQefl0djcRP9XWBN13a62",
    loaderOptions: {
        autoHideBadge : true,
    }
});

app.use(StoryblokVue, {
  accessToken: "NwUkw8cwpkvlGSQ6qDODuAtt",
  use: [apiPlugin],
});

app.use(ZiggyVue);

app.use(pinia);

app.mount("#app");
